/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SpesePrecedentiResponseDTO
 */
export interface SpesePrecedentiResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof SpesePrecedentiResponseDTO
     */
    idLavoro?: number;
    /**
     * 
     * @type {number}
     * @memberof SpesePrecedentiResponseDTO
     */
    idTipoRimborso?: number;
    /**
     * 
     * @type {Date}
     * @memberof SpesePrecedentiResponseDTO
     */
    data?: Date;
    /**
     * 
     * @type {string}
     * @memberof SpesePrecedentiResponseDTO
     */
    nota?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SpesePrecedentiResponseDTO
     */
    totale?: number;
}

/**
 * Check if a given object implements the SpesePrecedentiResponseDTO interface.
 */
export function instanceOfSpesePrecedentiResponseDTO(value: object): value is SpesePrecedentiResponseDTO {
    return true;
}

export function SpesePrecedentiResponseDTOFromJSON(json: any): SpesePrecedentiResponseDTO {
    return SpesePrecedentiResponseDTOFromJSONTyped(json, false);
}

export function SpesePrecedentiResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpesePrecedentiResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idLavoro': json['idLavoro'] == null ? undefined : json['idLavoro'],
        'idTipoRimborso': json['idTipoRimborso'] == null ? undefined : json['idTipoRimborso'],
        'data': json['data'] == null ? undefined : (new Date(json['data'])),
        'nota': json['nota'] == null ? undefined : json['nota'],
        'totale': json['totale'] == null ? undefined : json['totale'],
    };
}

export function SpesePrecedentiResponseDTOToJSON(json: any): SpesePrecedentiResponseDTO {
    return SpesePrecedentiResponseDTOToJSONTyped(json, false);
}

export function SpesePrecedentiResponseDTOToJSONTyped(value?: SpesePrecedentiResponseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idLavoro': value['idLavoro'],
        'idTipoRimborso': value['idTipoRimborso'],
        'data': value['data'] == null ? undefined : ((value['data']).toISOString()),
        'nota': value['nota'],
        'totale': value['totale'],
    };
}

